<template lang="pug">
.container
  .banner
    .swiper.swiper-banner
      .swiper-wrapper
        .swiper-slide
          img.img-fluid(src='images/banner/banner01.jpg')
        .swiper-slide
          img.img-fluid(src='images/banner/banner01.jpg')
        .swiper-slide
          img.img-fluid(src='images/banner/banner01.jpg')
</template>

<script>
export default{
  mounted() {
    // main banner
    var swiper = new Swiper(".swiper-banner", {
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".swiper-pagination",
        }
    });
  }
}
</script>